module.exports = __webpack_public_path__ + "static/img/10areaB_03.3b7ab70.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/10areaB_03.png
// module id = 1073
// module chunks = 1